export enum ButtonTypesEnum {
    primary,
    primaryB,
    secondary,
    tertiary,
    link,
    textToggle,
    big,
    block,
    icon,
    iconFilled,
    contextMenu,
    image,
    colorSwatch
}

export enum FocusedMoveButtonTypesEnum {
    up,
    down,
    all
}
